import { AudienceType, WorkflowType } from '@/client/services/api/graphql/gql/graphql';
import { Button, Collapse, Stack } from '@chakra-ui/react';
import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';
import { useEffect, useRef, useState } from 'react';

import AssignmentAudienceExtendAccessForm from './AssignmentAudienceExtendAccessForm';
import AssignmentAudienceHiredDateForm from './AssignmentAudienceHiredDateForm';
import { AssignmentFormData } from '../../../types/assignmentTypes';
import { useAccessHelper } from '@/client/services/hooks/auth/useAccessHelper';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export default function AssignmentAdditionalAudienceFiltersForm() {
  const { t } = useTranslation();

  const { allowance } = useAccessHelper();

  const [showAdditionalFilters, setShowAdditionalFilters] = useState<boolean>(false);
  const isInitialLoad = useRef(true);

  const { watch, setValue } = useFormContext<AssignmentFormData>();
  const { audience, settings } = watch();
  const { type } = settings;

  const isHiredDateAutomation =
    type === WorkflowType.HiredCustom ||
    type === WorkflowType.HiredToday ||
    type === WorkflowType.Hired_60 ||
    type === WorkflowType.Hired_90;

  const hiredDateFilter = audience.find((item) => item.type === AudienceType.HiredDate);

  const hasPartnerTypeFilter = audience.some((a) => a.type === AudienceType.PartnerType);

  useEffect(() => {
    if (hasPartnerTypeFilter) {
      setShowAdditionalFilters(true);
    }

    if (hiredDateFilter?.days != null && isInitialLoad.current) {
      setShowAdditionalFilters(true);
      setValue('useHiredDateAudienceFilter', true);
      isInitialLoad.current = false;
    }
  }, []);

  return (
    <>
      <Button
        fontSize="14px"
        fontWeight={600}
        border="1px solid"
        borderColor="transparent"
        borderRadius="8px"
        backgroundColor="white"
        color="baseBlack"
        display="flex"
        justifyContent="space-between"
        paddingX={4}
        paddingY={6}
        rightIcon={
          showAdditionalFilters ? <ChevronUpIcon boxSize={6} /> : <ChevronDownIcon boxSize={6} />
        }
        onClick={() => setShowAdditionalFilters(!showAdditionalFilters)}
        _hover={{
          cursor: 'pointer',
          backgroundColor: 'neutral.0',
          borderColor: 'neutral.100',
        }}
      >
        {t('admin.assignments.audience.additionalFilters')}
      </Button>

      <Collapse in={showAdditionalFilters} animateOpacity>
        <Stack paddingX={4} spacing={10}>
          {!isHiredDateAutomation && (
            <AssignmentAudienceHiredDateForm isInitialLoad={isInitialLoad.current} />
          )}

          {allowance.partners && <AssignmentAudienceExtendAccessForm />}
        </Stack>
      </Collapse>
    </>
  );
}
